var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pass-register__header"},[_c('r-title',[_vm._v(_vm._s(_vm.title))]),_c('r-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$emit('add')}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]),_c('export-button',{staticClass:"end",attrs:{"name":"Реестр пропусков","uri":_vm.exportUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }